import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { useForm } from 'react-hook-form'

import { Form } from '@/components/elements/form'

import QuizResultQuestion from './QuizResultQuestion'

function QuizResult({ quiz, gradedQuiz }) {
  const quizQuestions = useMemo(
    () =>
      (gradedQuiz?.answers ?? [])
        .map((answer) => {
          const question = quiz.questions.find((q) => q.id === answer.questionId)
          // The attempt records the question ids as they were when it was
          // taken. An edit to the course can retire a question, leaving an
          // answer with nothing to render against — skip it rather than
          // crashing the whole review on `question.id` (RSCX-385).
          if (!question) return null
          return {
            ...question,
            questionId: question.id,
            // Absent on a failed attempt: the API withholds the answer key so
            // retakes can't be farmed. Everything still renders — the review
            // just marks what the student got wrong without revealing what was
            // right.
            correctAnswers: answer.correctAnswers || [],
            isCorrect: answer.isCorrect,
            responses: answer.answers,
          }
        })
        .filter(Boolean),
    [quiz, gradedQuiz],
  )

  const defaultValues = useMemo(() => {
    const isSingle = ['Single Choice', 'True/False', 'Numeric']
    const obj = {}
    quizQuestions.forEach((q) => {
      obj[q.questionId] = isSingle.includes(q.type) ? q.responses[0] : q.responses
    })
    return obj
  }, [quizQuestions])

  const form = useForm({
    defaultValues,
    disabled: true,
  })

  return (
    <div className="max-w-5xl p-4">
      <Form {...form}>
        <div className="flex flex-col gap-6">
          {quizQuestions.map((question, index) => (
            <QuizResultQuestion
              key={question.id}
              question={question}
              index={index}
              control={form.control}
            />
          ))}
        </div>
      </Form>
    </div>
  )
}

export default QuizResult

QuizResult.propTypes = {
  quiz: PropTypes.object.isRequired,
  gradedQuiz: PropTypes.object.isRequired,
}
